import { ICalculatableObject } from "../../../../../../domain/editableFormat/objects";
import { ICalculatableObjectBean } from "../../../beans/objects";
import { AbstractObjectTranslator } from "../AbstractObjectTranslator";
import {
  PrintBehaviorTranslator,
  EditBehaviorTranslator,
  TooltipBehaviorTranslator,
  NaturalTextBehaviorTranslator,
  EmptyAlertBehaviorTranslator,
  LengthAlertBehaviorTranslator,
  FreeInputBehaviorTranslator,
  MultiLineBehaviorTranslator,
  InputRuleBehaviorTranslator,
} from "../properties";
import { TextDrawableObjectTranslator } from "./TextDrawableObjectTranslator";

export class CalculatableObjectTranslator<TObject extends ICalculatableObject, TBean extends ICalculatableObjectBean> extends AbstractObjectTranslator<TObject, TBean> {
  constructor() {
    super(new TextDrawableObjectTranslator());
  }

  overwriteObject(source: TObject, bean: TBean, formatId: number): void {
    source.printBehavior = this.printBehavior.from(bean);
    source.editBehavior = this.editBehavior.from(bean);
    source.tooltipBehavior = this.tooltipBehavior.from(bean);
    source.naturalTextBehavior = this.naturalTextBehavior.from(bean);
    source.emptyAlertBehavior = this.emptyAlertBehavior.from(bean);
    source.lengthAlertBehavior = this.lengthAlertBehavior.from(bean);
    source.freeInputBehavior = this.freeInputBehavior.from(bean);
    source.multiLineBehavior = this.multiLineBehavior.from(bean);
    source.inputRuleBehavior = this.inputRuleBehavior.from(bean);
  }

  overwriteBean(source: TBean, object: TObject): void {
    source["@hide"] = this.printBehavior.to(object).hide;
    source["@vanish"] = this.editBehavior.to(object).vanish;
    source["@tooltip"] = this.tooltipBehavior.to(object).tooltip;
    source["@natural-view"] = this.naturalTextBehavior.to(object).naturalView;
    source["@natural-text"] = this.naturalTextBehavior.to(object).naturalText;
    source["@empty-check"] = this.emptyAlertBehavior.to(object).emptyCheck;
    source["@data-check"] = this.lengthAlertBehavior.to(object).dataCheck;
    source["@length-check"] = this.lengthAlertBehavior.to(object).lengthCheck;
    source["@free-input-enable"] = this.freeInputBehavior.to(object).freeInputEnable;
    source["@type"] = this.multiLineBehavior.to(object).type;
    source["@space-line"] = "-1"; // 入力UIなし.固定らしい.
    source["@data-validation"] = this.inputRuleBehavior.to(object).dataValidation;
  }

  private readonly printBehavior = new PrintBehaviorTranslator();
  private readonly editBehavior = new EditBehaviorTranslator();
  private readonly tooltipBehavior = new TooltipBehaviorTranslator();
  private readonly naturalTextBehavior = new NaturalTextBehaviorTranslator();
  private readonly emptyAlertBehavior = new EmptyAlertBehaviorTranslator();
  private readonly lengthAlertBehavior = new LengthAlertBehaviorTranslator();
  private readonly freeInputBehavior = new FreeInputBehaviorTranslator();
  private readonly multiLineBehavior = new MultiLineBehaviorTranslator();
  private readonly inputRuleBehavior = new InputRuleBehaviorTranslator();
}
